import { render } from "./EditInternalProductsModal.vue?vue&type=template&id=563c856e"
import script from "./EditInternalProductsModal.vue?vue&type=script&lang=js"
export * from "./EditInternalProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__